// @flow

import {colors} from '@pb/kit-stylus/config.json';
import {tableCellName, tableRowName} from '../constants';

type CreateStyleVerticalLineOnResize = ({
    colorLine?: string,
    isLastChild?: boolean,
    columnIndex: number,
    isFixed: boolean,
    tableId: string,
}) => HTMLStyleElement;

export const createStyleVerticalLineOnResize: CreateStyleVerticalLineOnResize = ({
    colorLine = colors.secondaryColors.orange,
    isLastChild,
    columnIndex,
    isFixed,
    tableId,
}) => {
    const style = document.createElement('style');

    if (isFixed) {
        if (isLastChild) {
            style.textContent = `#${tableId} .${tableRowName}_fixed .${tableCellName}:last-child::before {
                background-color: ${colorLine};
            }`;
        } else {
            style.textContent = `#${tableId} .${tableRowName}_fixed .${tableCellName}-${columnIndex} {
                border-right-color: ${colorLine};
            }`;
        }
    } else {
        style.textContent = `#${tableId} .${tableRowName}:not([class*=fixed]) .${tableCellName}-${columnIndex} {
            border-right-color: ${colorLine};
        }`;
    }

    return style;
};
